'use strict';

var chunkINBWZDPQ_js = require('./chunk-INBWZDPQ.js');
require('./chunk-H4LCK5US.js');
var chunk63SERZLX_js = require('./chunk-63SERZLX.js');



Object.defineProperty(exports, "PromiseQueueManager", {
	enumerable: true,
	get: function () { return chunkINBWZDPQ_js.a; }
});
Object.defineProperty(exports, "promiseQueueManager", {
	enumerable: true,
	get: function () { return chunkINBWZDPQ_js.b; }
});
Object.defineProperty(exports, "InitializeMsalInstance", {
	enumerable: true,
	get: function () { return chunk63SERZLX_js.a; }
});
Object.defineProperty(exports, "fetchAccessToken", {
	enumerable: true,
	get: function () { return chunk63SERZLX_js.d; }
});
Object.defineProperty(exports, "login", {
	enumerable: true,
	get: function () { return chunk63SERZLX_js.c; }
});
Object.defineProperty(exports, "logout", {
	enumerable: true,
	get: function () { return chunk63SERZLX_js.b; }
});
